<app-timeline-progress-bar [steps]="steps" (clickEvent)="navigate($event)"></app-timeline-progress-bar>
